<template>
    <div class="stage">
        <div class="questions-wrapper">
            <div class="questions-block">
                <div class="question-block">
                    <div class="question">
                        Який у пацієнта результат базової ПЕТ-КТ?
                    </div>
                    <div class="answers">
                        <div class="answer" :class="baseKtResult === 'D1-3' ? 'active' : ''" @click="baseKtResult = 'D1-3'">
                            <input type="radio" id="D1-3" name="baseKtResult" v-model="baseKtResult" value="D1-3" required>
                            <label for="D1-3"><strong>D1-3</strong></label>
                        </div>
                        <div class="answer" :class="baseKtResult === 'D4' ? 'active' : ''" @click="baseKtResult = 'D4'">
                            <input type="radio" id="D4" name="baseKtResult" v-model="baseKtResult" value="D4" required>
                            <label for="D4"><strong>D4</strong></label>
                        </div>
                        <div class="answer" :class="baseKtResult === 'D5' ? 'active' : ''" @click="baseKtResult = 'D5'">
                            <input type="radio" id="D5" name="baseKtResult" v-model="baseKtResult" value="D5" required>
                            <label for="D5"><strong>D5</strong></label>
                        </div>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../../../components/Doctor/ErrorBlock';
import { mapMutations, mapGetters } from 'vuex';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        baseKtResult : '',
    }),
    computed : {
        ...mapGetters([
            'getBasePetKtResult'
        ])
    },
    methods : {
        ...mapMutations([
            'setBasePetKtResult',
        ])
    },
    created(){
        this.baseKtResult = this.getBasePetKtResult;
    },
    watch : {
        baseKtResult : function(value){
            this.setBasePetKtResult(value);
        }
    }
}
</script>

<style lang="scss" scoped>
.stage{
    .questions-wrapper{
        width: 325px;
        height: auto;

        .questions-block{
            padding: 20px 40px;

            .question-block{
                .question{
                    font-size: 26px;
                }

                .answers{
                    padding-bottom: 0;

                    .answer{
                        width: 65%;

                        label{
                            font-size: 12px;
                            font-weight: 300;

                            strong{
                                padding-right: 3px;
                                font-size: 14px;
                            }
                        }
                    }

                    .answer:nth-child(2n){
                        margin-left: 0;
                    }
                }
            }           
        }        
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .questions-wrapper{
            width: 35vw;
            height: auto;

            .questions-block{
                padding: 3.125vw 3.333vw;

                .question-block{
                    .question{
                        font-size: 1.667vw;
                    }

                    .answers{
                        .answer{
                            width: 45%;

                            label{
                                font-size: 0.95vw;

                                strong{
                                    font-size: 1.042vw;
                                }
                            }
                        }
                    }
                }           
            }
        }
    }
}

@media (max-width: 599px){
    .stage{
        .questions-wrapper{
            width: 100%;
            height: auto;

            .questions-block{
                padding: 5.556vw 5.278vw 6.667vw 5.556vw;

                .question-block{
                    .question{
                        font-size: 5.556vw;
                    }

                    .answers{
                        .answer{
                            label{
                                font-size: 3.889vw;

                                strong{
                                    padding-right: 3px;
                                    font-size: 4vw;
                                }
                            }
                        }

                        .answer:nth-child(2n){
                            margin-left: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>